import { useScrollAnimation } from '@/hooks/useScrollAnimation';

export default function FinalCTA() {
  const [ref, isVisible] = useScrollAnimation(0.1);

  const scrollToDemo = () => {
    const el = document.querySelector('#demo-form');
    if (el) el.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <section className="py-24 md:py-32 px-4 md:px-8 bg-vf-forest">
      <div ref={ref} className={`max-w-3xl mx-auto text-center scroll-fade-up ${isVisible ? 'visible' : ''}`}>
        <h2 className="font-heading font-bold text-3xl sm:text-4xl lg:text-5xl text-white tracking-tight mb-6 leading-tight">
          Your patients need you present. Not buried in paperwork.
        </h2>
        <p className="font-body text-base md:text-lg text-white/60 max-w-xl mx-auto mb-10 leading-relaxed">
          Join our pilot program. Free for the first 3 months for qualifying Rural Health Clinics.
        </p>
        <button
          data-testid="final-cta-button"
          onClick={scrollToDemo}
          className="font-body text-sm font-bold uppercase tracking-[0.15em] bg-vf-mint text-vf-charcoal px-10 py-4 hover:bg-vf-mint/80 transition-all duration-300"
        >
          Request Your Free Demo
        </button>
        <p className="font-body text-xs text-white/40 mt-6">
          No commitment. No hardware. Setup in under 30 minutes.
        </p>
      </div>
    </section>
  );
}
